import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import settings from 'settings';

let appInsights: ApplicationInsights | null = null;

export function initAppInsights(connectionString?: string) {
	const cs = connectionString ?? (settings as any).applicationInsightsConnectionString;
	if (!cs || appInsights) return;

	appInsights = new ApplicationInsights({
		config: {
			connectionString: cs,
			enableAutoRouteTracking: true, // Vue router page views
			// disableFetchTracking: false, // optional
		},
	});
	appInsights.loadAppInsights();
	appInsights.trackPageView();
}

export function trackEvent(name: string, properties?: Record<string, string | number | boolean>) {
	appInsights?.trackEvent({ name }, properties);
}

export function trackException(error: Error, properties?: Record<string, string>) {
	appInsights?.trackException({ exception: error }, properties);
}
